export const CONTINUE_REGISTRATION = 'CONTINUE_REGISTRATION';
export const CONTINUE_REGISTRATION_FAILED = 'CONTINUE_REGISTRATION_FAILED';
export const CONTINUE_REGISTRATION_SUCCESS = 'CONTINUE_REGISTRATION_SUCCESS';
export const GET_BLOOD_TYPES = 'GET_BLOOD_TYPES';
export const GET_BLOOD_TYPES_FAILED = 'GET_BLOOD_TYPES_FAILED';
export const GET_BLOOD_TYPES_SUCCESS = 'GET_BLOOD_TYPES_SUCCESS';
